<template>
    <div class="basic_wrap">
		<div class="top">
			<img src="../images/ban2/logo.svg">
		</div>
		<div class="form">
			<div class="title">Login atau buat akun </div>
			<div class="subdesc">
				Buka dunia perjalanan dengan satu akun di Expedia, Hotels.com, dan Vrbo.
			</div>
		</div>
        <div class="form">

            <div class="item ">
				<!-- <span class="icon">
					<van-icon name="phone-o" size="25"/>
				</span> -->
				<input
                    type="text"
                    class="inp"
                    v-model.trim="data.username"
                    placeholder="Username"
                />
            </div>
            <div class="item">
				<!-- <span class="icon">
					<van-icon name="lock" size="25"/>
				</span> -->
				<input
                    :type="password"
                    class="inp"
                    v-model.trim="data.password"
                    :placeholder="$t('login.password')"
                />
                <div
                    class="eye_bi"
                    @click="showPwd"
                    :class="password == 'text' ? 'eye' : ''"
                ></div>
            </div>
            <!-- <div class="item_reset_pwd">
				<van-checkbox v-model="checked" icon-size="14px">{{$t('login.remember')}}</van-checkbox>
                <router-link class="reset_pwd" to="/forgetpwd">{{$t('login.forget')}}</router-link>
            </div> -->
			<div
			    type="submit"
			    class="basic_btn sbtn"
			    :class="
			        data.username == '' || data.password == '' ? 'no_touch' : ''
			    "
			    @click="submit"
			>
			    {{$t('login.signInBtn')}}
			</div>
			<!-- <div @click="$router.push('/register')"
				class="basic_btn sbtn">
				{{$t('login.signUp')}}
			</div> -->
			<div class="geli">
				<div class="geli1"></div>
				<span class="gelitext">{{$t('pro2.atau')}}</span>
				<div class="geli2"></div>
			</div>
			<div @click="$router.push('/register')" class="cont_textCon_but cont_textCon_but1 flexCenter">
				{{$t('register.signUpBtn')}}
			</div>
			<!-- <p  class="tip">
				{{$t('feng.noacc')}}
				<a @click="$router.push('/register')">{{$t('feng.goreg')}}</a>
			</p> -->
        </div>
        <!-- <div class="bottomImg">
			<img    src="../images/ban1/links.png">
		</div> -->
		
		<div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
			<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
			<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
			<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
		</div>
       <!-- <div
            v-if="msg_show"
            class="kefu"
            :class="show_kefu ? '' : 'kefu_hide'"
            @click="kefu_to"
        >
            <a v-if="show_kefu" :href="app.kefu_link" target="_blank">
            	<img class="kefu_img" src="../images/shop2/kefu.png">
            </a>
            <img v-if="!show_kefu" class="kefu_img" src="../images/shop2/kefu.png">
        </div> -->
    </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {CountDown, Icon,Checkbox} from 'vant'
Vue.use(Checkbox).use(Icon);

export default {
    name: "login",
    data() {
        return {
			lang:this.$i18n.locale||"zh_cn",
            password: "password",
            show_kefu: false,
            msg_show: true,
			checked: true,
			app: null,
            data: {
                username: "",
                password: "",
            }
        };
    },
    created() {
		this.data.username = localStorage.getItem('login_username');
		this.data.password = localStorage.getItem('login_password');
        this.$parent.footer("user", false);
    },
    mounted() {
        var that = this;
		this.start();
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
		start() {
			Fetch("/index/webconfig").then((r) => {
				this.app = r.data;
			});
		},
        kefu_to() {
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            if (!this.data.username) {
                this.$toast(this.$t('login.phoneEmpty'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }
			
			if(this.checked){
				localStorage.setItem('login_username', this.data.username);
				localStorage.setItem('login_password', this.data.password);
			}
			
			if(!this.checked){
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');
			}

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password
            })
                .then((res) => {
					if(res.data.token){
					    localStorage.setItem('token', res.data.token);
					}
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                })
                .then(() => {
                    this.$router.replace({
                        path:
                            this.$router.history.current.query.redirect || "/",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.login_bg {
    width: 100%;
	height: 48px;
	background: #0064d3;
    overflow: hidden;
    background-size: 100% 100%;
	.language{
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;
		img{
			height: 100%;
		}
	}
}

.basic_wrap{
	// background-image: url(../images/ban1/bg.png);
	background-size: cover;
	background-position: center center;
}
.basic_wrap .form {
    margin: 0px auto 0 auto;
    width: 100%;
    box-shadow:none;
    border-radius: 13px;
    padding: 2vh 5vw;
	background: none;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #ceced0;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }

    a.cur {
        color: #0063d2;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #0063d2, #f18a11);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 68px;
    border-bottom: 1px solid #e4e4e4;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;
    .icon {
        width: 32px;
        height: 27px;
        img {
            height: 100%;
        }
    }
    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: green;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
	margin-bottom: 50px;
}
.van-checkbox{
	margin-top: 20px;
}
.reset_pwd{
	color: #0063d2;
	margin-top: -20px;
	display: block;
}

.basic_btn {
    margin: 10% auto 0 auto;
}
.big_tit{
	color: #FFFFFF;
}
/deep/ .van-checkbox__icon--checked .van-icon{
    color: #fff;
    background-color: #0063d2;
    border-color: #0063d2;
}
/deep/ .item .van-icon {
    color: #000;
	font-size:20px !important;
}
/deep/ .van-checkbox__label{
	
}

.van-field__label{
	-webkit-box-flex: 0;
	-webkit-flex: none;
	flex: none;
	box-sizing: border-box;
	width: 24vw;
	margin-right: 3.2vw;
	color: #646566;
	text-align: left;
	word-wrap: break-word;
	width: 100%;
	font-size: 3.73333vw;
	color: #727d91;
}

#appLogo{
	display: block;
	width: 150px;
	margin: 0.5rem auto 0rem;
}
input::placeholder {
    color: #999; /* 设置提示字符串颜色 */
}
.tip{
		text-align: left;
		line-height: 30px;
		font-size: 14px;
		color: #666;
		margin-top: 10px;
		a{
			color: #0063d2;
			text-decoration: underline;
		}
	}
	
	.topbaner{
		width: 100%;
	}
	.bottomImg{
		display: flex;
		justify-content: center;
		margin-top: 57px;
		img{
			width: 320px;
		}
	}
	.basic_btn{
		font-weight: bold;
		height: 39px;
		line-height: 39px;
		border-radius: 36px;
		font-size: 15px;
	}
	.cont_textCon_but1 {
		height: 39px;
		border-radius: 36px;
		font-size: 15px;
		font-weight: bold;
	    background: #fff;
	    color: #0063d2;
	    border: 1px solid #0063d2;
	    margin-top: 15px;
		background: #0063d2 !important;
		color: #fffffd !important;
	}
	.flexCenter {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	
	.top{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 8px;
		margin-top: 5px;
		img{
			height: 35px;
		}
		.topt{
			font-size: 14px;
			line-height: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 4px;
		}
	}
	.geli{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px;
		.geli1{
			width: 32px;
			border-color: #aeb2be;
			border-top: 1px solid #d8dce8;
			margin-right: 8px!important;
		}
		.gelitext{
			font-size: 12px;
			line-height: 16px;
			margin-right: 8px!important;
			color: #71747d;
		}
		.geli2{
			width: 32px;
			border-color: #aeb2be;
			border-top: 1px solid #d8dce8;
		}
	}
	.footimgs{
		height: 25px;
		margin: 0 5px;
	}
	.form{
		.title{
			margin-top: 30px;
			font-size: 18px;
			line-height: 30px;
			font-weight: bold;
			color: #000;
		}
		.subdesc{
			margin-top: 10px;
			font-size: 12px;
			line-height:20px;
		}
	}
</style>
